export const plural = ({ singular, plural, count }) =>
  count > 1 ? plural : singular;
